import React from 'react'
import { IconButton } from '@tecuity/granite-ui/IconButton'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import TrashHeavy from '@tecuity/sos-icons/react/trash-heavy'
import CrossHeavy from '@tecuity/sos-icons/react/cross-heavy'
import Revert from '@tecuity/sos-icons/react/revert'
import { GET_IS_ORIGINAL_IMAGE } from '../../requests'
// import { shallowEqual, useSelector } from 'react-redux';

const ImageGroup = ({
  name,
  pages = [],
  onSelectGroup,
  onSelectPage,
  isActive,
  activePageIndex = 0,
  statusID,
  groupId,
  canUserDeleteImage,
  showConfirmDelete,
  setShowConfirmDelete,
  deleteImage,
  canUserUnredactImage,
  showConfirmUnredact,
  setShowConfirmUnredact,
  unredactImage,
}) => {
  const [isOriginal, setIsOriginal] = React.useState(true)

  React.useEffect(() => {
    GET_IS_ORIGINAL_IMAGE(
      groupId,
      (res) => setIsOriginal(res.isOriginal),
      (err) => console.error(groupId, err)
    )
  }, [groupId])

  return (
    <div className="image-group">
      <div className="image-group-header" onClick={onSelectGroup}>
        <span className="image-group-header-title">{name}</span>
        <div className="image-group-status">
          {statusID === 549 ? (
            <div title="Status: Complete">✅</div>
          ) : statusID === 559 ? (
            <div title="Status: Needs Correction" style={{ fontSize: '1.2em', color: 'yellow' }}>
              ⚠
            </div>
          ) : statusID === 540 ? (
            <div title="Status: Rejected">❌</div>
          ) : (
            <div title="Status: New" style={{ fontSize: '1.3em' }}>
              ☐
            </div>
          )}
        </div>
      </div>
      <ul className="image-group-pages">
        {pages.map((page, i) => (
          <li key={page.DLN + i}>
            <div className={'image-active-row'}>
              <button
                className="image-page"
                data-active={isActive && activePageIndex === i}
                onClick={() => onSelectPage(i)}
              >
                {page.DLN}
              </button>
              {canUserUnredactImage() &&
                !isOriginal &&
                isActive &&
                activePageIndex === i && (
                  <span
                    title={showConfirmUnredact ? `Cancel Unredact` : `Unredact group ${groupId}`}
                  >
                    <IconButton
                      onClick={() => {
                        setShowConfirmUnredact(!showConfirmUnredact)
                      }}
                      icon={showConfirmUnredact ? <CrossHeavy /> : <Revert />}
                      label={showConfirmUnredact ? `Cancel Unredact` : `Unredact Group ${groupId}`}
                      customCss={{
                        color: 'white',
                        svg: {
                          height: '22px',
                          width: '22px',
                          marginTop: '-17px',
                          marginBottom: '-5px',
                        },
                      }}
                    />
                  </span>
                )}
              {canUserDeleteImage(statusID, page.useHtmlRedaction /* populated with TAGGED_YN */) && i > 0 &&
                isActive &&
                activePageIndex === i && (
                  <span title={showConfirmDelete ? `Cancel Delete` : `Delete Image ${page.DLN}`}>
                    <IconButton
                      onClick={() => {
                        setShowConfirmDelete(!showConfirmDelete)
                      }}
                      icon={showConfirmDelete ? <CrossHeavy /> : <TrashHeavy />}
                      label={showConfirmDelete ? `Cancel Delete` : `Delete Image ${page.DLN}`}
                      customCss={{
                        color: 'white',
                        svg: {
                          height: '22px',
                          width: '22px',
                          marginTop: '-17px',
                          marginBottom: '-5px',
                        },
                      }}
                    />
                  </span>
                )}
            </div>
            {canUserUnredactImage() &&
              isActive &&
              activePageIndex === i &&
              showConfirmUnredact && (
                <div className="image-delete-confirm">
                  <span>Are you sure you want to Unredact this image?</span>
                  <div className="image-delete-confirm-actions">
                    <ContextButton
                      variant={'success'}
                      onClick={() => {
                        unredactImage(page.DLN)
                        setShowConfirmUnredact(false)
                      }}
                    >
                      Yes
                    </ContextButton>
                    <ContextButton
                      variant={'danger'}
                      onClick={() => {
                        setShowConfirmUnredact(false)
                      }}
                    >
                      No
                    </ContextButton>
                  </div>
                </div>
              )}
            {canUserDeleteImage(statusID, page.useHtmlRedaction /* populated with TAGGED_YN */) &&
              isActive &&
              activePageIndex === i &&
              showConfirmDelete && (
                <div className="image-delete-confirm">
                  <span>Are you sure you want to Delete this image?</span>
                  <div className="image-delete-confirm-actions">
                    <ContextButton
                      variant={'success'}
                      onClick={() => {
                        deleteImage(
                          statusID,
                          page.DLN,
                          page.useHtmlRedaction /* populated with TAGGED_YN */
                        )
                        setShowConfirmDelete(false)
                      }}
                    >
                      Yes
                    </ContextButton>
                    <ContextButton
                      variant={'danger'}
                      onClick={() => {
                        setShowConfirmDelete(false)
                      }}
                    >
                      No
                    </ContextButton>
                  </div>
                </div>
              )}
            {page.type !== name && page.type !== 'Additional page' && (
              <div style={{ fontSize: '12px' }}>- {page.type}</div>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}
export default ImageGroup
